import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Form } from '../../interfaces/form-structure-interfaces';
import { FormControl, FormGroup } from '@angular/forms';
import { clone } from '../../../support/helpers/clone.function';

@Component({
    selector: 'chassis-core-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
    @Input() entity: any;

    @Input() static = false;

    @Input() structure: Form;

    @Output() submit: EventEmitter<any> = new EventEmitter();

    public cloneEntity: any;

    ngOnInit() {
        if (this.entity) {
            this.cloneEntity = clone(this.entity);
        }

        const formGroup = new FormGroup({});

        // Create form group/controls
        if (this.structure) {
            for (const tab of this.structure.tabs) {
                const tabGroup = new FormGroup({});
                for (const section of tab.sections) {
                    for (const column of section.columns) {
                        for (const element of column.elements) {
                            const formControl = new FormControl('');

                            element['formControl'] = formControl;

                            tabGroup.addControl(element.id, formControl);
                        }
                    }
                }
            }
        }
    }

    public save() {
        console.log('Form | Save');

        // Emit event
        this.submit.emit(this.cloneEntity);
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/resources/components/form/form.component.ts